module.exports = __webpack_public_path__ + "img/ws.f9652fd6.png";